// French for the evidence corpus: masthead, rail, holds, the grid, the panel, the modals.
import { registerFr } from '../i18n/index.js';

registerFr({
  // ── masthead ──
  'Documents': 'Documents',
  'No engagement selected': 'Aucun mandat sélectionné',
  'Evidence is always scoped to one engagement — pick one in the top bar and its corpus loads here.': 'Les preuves appartiennent toujours à un seul mandat — choisissez-en un dans la barre supérieure, et son corpus se charge ici.',
  'Release to ingest into': 'Relâcher pour ingérer dans',
  'The evidence corpus of': 'Le corpus de preuves de',
  'everything a requirement is allowed to cite': 'tout ce qu’une exigence est autorisée à citer',
  'Link documents the client library already has — nothing is copied': 'Lier des documents que la bibliothèque client possède déjà — rien n’est copié',
  'Add from library': 'Ajouter depuis la bibliothèque',
  'New note': 'Nouvelle note',
  'Ingesting…': 'Ingestion en cours…',
  'Upload files': 'Téléverser des fichiers',

  // ── the rail (t(cell.key) + units/details) ──
  'CORPUS': 'CORPUS',
  'DATED': 'DATÉ',
  'READ': 'LU',
  'PAIRS': 'PAIRES',
  'YIELD': 'RENDEMENT',
  'filter': 'filtre',
  'the corpus did not load': 'le corpus n’a pas été chargé',
  'doc': 'doc.',
  'docs': 'doc.',
  '{live} live · {superseded} superseded': '{live} actif(s) · {superseded} remplacé(s)',
  '{live} live · none superseded': '{live} actif(s) · aucun remplacé',
  '{a} of {b}': '{a} sur {b}',
  '{n} effective date unconfirmed': '{n} date d’effet non confirmée',
  '{n} effective dates unconfirmed': '{n} dates d’effet non confirmées',
  'every effective date confirmed': 'toutes les dates d’effet confirmées',
  '{n} awaiting OCR': '{n} en attente d’OCR',
  'every document has a text layer': 'tous les documents ont une couche de texte',
  'open': 'ouvert',
  'near-duplicates undecided': 'quasi-doublons non tranchés',
  'every near-duplicate decided': 'tous les quasi-doublons tranchés',
  'span': 'extrait',
  'spans': 'extraits',
  '{cited} of {live} cited · {dark} dark': '{cited} sur {live} cité(s) · {dark} non cité(s)',
  'every document cited': 'tous les documents cités',

  // ── toasts ──
  'Failed to load document': 'Impossible de charger le document',
  '{n} ingested': '{n} ingéré(s)',
  '{n} already on file': '{n} déjà enregistré(s)',
  '{n} not accepted': '{n} non accepté(s)',
  'Nothing was ingested': 'Rien n’a été ingéré',
  '{summary} — the per-file report is the first hold': '{summary} — le rapport par fichier est la première réserve',
  'Upload failed': 'Échec du téléversement',
  'Upload failed — {reason}': 'Échec du téléversement — {reason}',
  'Effective date confirmed': 'Date d’effet confirmée',
  'Could not confirm date': 'Impossible de confirmer la date',
  'None of the selected documents has a detected date waiting to be confirmed': 'Aucun des documents sélectionnés n’a de date détectée en attente de confirmation',
  '{done} confirmed · {refused} refused — {reason}': '{done} confirmé(s) · {refused} refusé(s) — {reason}',
  '{n} date': '{n} date',
  '{n} dates': '{n} dates',
  '{n} effective date confirmed in one act': '{n} date d’effet confirmée en une fois',
  '{n} effective dates confirmed in one act': '{n} dates d’effet confirmées en une fois',
  'Could not confirm the dates': 'Impossible de confirmer les dates',
  'Date set and confirmed': 'Date définie et confirmée',
  'Could not set the date': 'Impossible de définir la date',
  'Re-reading — the current text will be replaced': 'Nouvelle lecture en cours — le texte actuel sera remplacé',
  'Queued for reading': 'Mis en file pour la lecture',
  'Could not start OCR': 'Impossible de démarrer l’OCR',
  'None of the selected documents is a format the vision model can read': 'Aucun des documents sélectionnés n’a un format que le modèle de vision peut lire',
  'Queued {done} of {total} — {failed} could not start': '{done} sur {total} mis en file — {failed} n’ont pas pu démarrer',
  'Queued {n} document for reading': '{n} document mis en file pour la lecture',
  'Queued {n} documents for reading': '{n} documents mis en file pour la lecture',
  'Queued — the librarian will replace the current classification': 'Mis en file — le bibliothécaire remplace la classification actuelle',
  'Queued for classification': 'Mis en file pour la classification',
  'Could not start the librarian': 'Impossible de démarrer le bibliothécaire',
  'None of the selected documents has text for the librarian to read': 'Aucun des documents sélectionnés n’a de texte que le bibliothécaire puisse lire',
  'Queued {done} of {total} for re-filing — {failed} could not start': '{done} sur {total} mis en file pour le reclassement — {failed} n’ont pas pu démarrer',
  'Queued {n} document for re-filing': '{n} document mis en file pour le reclassement',
  'Queued {n} documents for re-filing': '{n} documents mis en file pour le reclassement',
  'Classification held — it is yours now, not the librarian’s': 'Classification retenue — elle vous appartient désormais, plus au bibliothécaire',
  'Could not hold the classification': 'Impossible de retenir la classification',
  '{ref} updated': '{ref} mis à jour',
  'Update failed': 'Échec de la mise à jour',
  'Marked as superseded': 'Marqué comme remplacé',
  'Supersession cleared': 'Remplacement annulé',
  'Supersession failed': 'Échec du remplacement',
  'Supersession recorded — recency arbitration now has an order': 'Remplacement enregistré — l’arbitrage de récence a désormais un ordre',
  'Recorded as reviewed — the hint keeps its reason, the badge stands down': 'Enregistré comme vérifié — l’indice garde sa justification, le badge se retire',
  'Could not dismiss the hint': 'Impossible d’écarter l’indice',
  '{n} linked to existing': '{n} lié(s) à des documents existants',
  '{n} already present': '{n} déjà présent(s)',
  '{n} still unsupported': '{n} toujours non pris en charge',
  'Re-scan of {ref}: {parts}': 'Nouveau scan de {ref} : {parts}',
  'Re-scan of {ref}: no attachments found': 'Nouveau scan de {ref} : aucune pièce jointe trouvée',
  'Attachment re-scan failed': 'Échec du nouveau scan des pièces jointes',
  'Could not work out what deleting this would do': 'Impossible de déterminer l’effet de cette suppression',
  '{ref} deleted — the stored file went with it': '{ref} supprimé — le fichier stocké est parti avec',
  '{ref} deleted': '{ref} supprimé',
  'Delete failed': 'Échec de la suppression',
  '{ref} unlinked from {code} — it stays in the client library': '{ref} dissocié de {code} — il reste dans la bibliothèque client',
  'Could not unlink the document': 'Impossible de dissocier le document',
  'refused': 'refusé',
  '{done} unlinked · {refused} refused — {first}': '{done} dissocié(s) · {refused} refusé(s) — {first}',
  '{n} document unlinked from {code}': '{n} document dissocié de {code}',
  '{n} documents unlinked from {code}': '{n} documents dissociés de {code}',
  'this engagement': 'ce mandat',
  '{ref} note created': 'Note {ref} créée',
  'Could not save note': 'Impossible d’enregistrer la note',
  'Could not load the client library': 'Impossible de charger la bibliothèque client',
  '{ref} linked into {code} — it stays in the client library': '{ref} lié à {code} — il reste dans la bibliothèque client',
  'Could not link the document': 'Impossible de lier le document',

  // ── HOLDS ──
  'Holds': 'Réserves',
  '{n} kind of hold': '{n} type de réserve',
  '{n} kinds of hold': '{n} types de réserves',
  'clear‖holds': 'libre',
  'clear‖filter': 'réinitialiser',
  'The corpus did not load': 'Le corpus n’a pas été chargé',
  'Nothing is holding the corpus': 'Rien ne retient le corpus',
  'Every effective date confirmed, every near-duplicate decided, every readable file read. The corpus is ready for extraction.': 'Toutes les dates d’effet confirmées, tous les quasi-doublons tranchés, tous les fichiers lisibles lus. Le corpus est prêt pour l’extraction.',
  'Last ingest —': 'Dernière ingestion —',
  'file': 'fichier',
  'files': 'fichiers',
  'ingested': 'ingéré',
  'already on file': 'déjà enregistré',
  'not accepted': 'non accepté',
  '— a file that never became a document is a hold, not a toast.': '— un fichier qui n’est jamais devenu un document est une réserve, pas une notification.',
  'Dismiss': 'Masquer',
  'created': 'créé',
  'The client library already had these bytes — the existing document was linked in': 'La bibliothèque client avait déjà ces octets — le document existant a été lié',
  'linked': 'lié',
  'duplicate': 'doublon',
  'failed': 'échoué',
  'Recorded on the existing document': 'Noté sur le document existant',
  're-uploaded': 'retéléversé',
  'Open': 'Ouvrir',
  'effective date unconfirmed': 'date d’effet non confirmée',
  'effective dates unconfirmed': 'dates d’effet non confirmées',
  'Until you confirm them, recency arbitration is running on Signet’s guess.': 'Tant que vous ne les confirmez pas, l’arbitrage de récence se fonde sur l’hypothèse de Signet.',
  '{n} of them have no detected date at all — set those by hand in the grid.': '{n} d’entre eux n’ont aucune date détectée — définissez-les à la main dans la grille.',
  'Hide the list': 'Masquer la liste',
  'Check the list': 'Vérifier la liste',
  'Confirming…': 'Confirmation en cours…',
  'Confirm {n}': 'Confirmer {n}',
  'detected from {source}': 'détecté depuis {source}',
  'source': 'source',
  'no date found — set it by hand': 'aucune date trouvée — à définir à la main',
  'Unticking a row leaves it unconfirmed and in the count; correcting a date is one click on the date cell in the grid.': 'Décocher une ligne la laisse non confirmée et dans le compte ; corriger une date se fait d’un clic sur la cellule de date dans la grille.',
  'near-duplicate pair undecided': 'paire de quasi-doublons non tranchée',
  'near-duplicate pairs undecided': 'paires de quasi-doublons non tranchées',
  'While a pair is open, recency arbitration has no order and the agent may cite the stale half of it.': 'Tant qu’une paire reste ouverte, l’arbitrage de récence n’a pas d’ordre, et l’agent pourrait citer la moitié périmée.',
  'Close': 'Fermer',
  'Decide pairs': 'Trancher les paires',
  'document with no text layer': 'document sans couche de texte',
  'documents with no text layer': 'documents sans couche de texte',
  'Stored and flagged, never dropped — but nothing can cite a document Signet cannot read.': 'Stocké et signalé, jamais abandonné — mais rien ne peut citer un document que Signet ne peut pas lire.',
  'The vision model is unreachable': 'Le modèle de vision est inaccessible',
  'Read {n} with OCR': 'Lire {n} avec l’OCR',
  'document the agent has never opened': 'document que l’agent n’a jamais ouvert',
  'documents the agent has never opened': 'documents que l’agent n’a jamais ouverts',
  'Never in any run’s': 'Jamais, dans aucune exécution, sous',
  'G1 cannot close on a corpus nobody has read.': 'Le G1 ne peut pas clore sur un corpus que personne n’a lu.',
  'Show them': 'Afficher',
  'Queue for extraction': 'Mettre en file pour l’extraction',

  // ── CORPUS ──
  'Corpus': 'Corpus',
  '{shown} of {total} documents': '{shown} sur {total} documents',
  '{n} document': '{n} document',
  '{n} documents': '{n} documents',
  'No evidence ingested yet': 'Aucune preuve ingérée pour l’instant',
  'Nothing is linked to': 'Rien n’est lié à',
  'Drop the discovery corpus onto this page — transcripts, client specs, screenshots — or link what the client library already has.': 'Déposez le corpus Discovery sur cette page — transcriptions, spécifications client, captures d’écran — ou liez ce que la bibliothèque client possède déjà.',
  'All': 'Tous',
  'none filed as {folders}': 'aucun classé comme {folders}',
  'Sorting': 'Tri',
  'by effective date, newest first': 'par date d’effet, la plus récente en premier',
  'by yield, richest first': 'par rendement, le plus riche en premier',
  'by ingest, newest first': 'par ingestion, la plus récente en premier',
  'Search refs, names, summaries, tags, full text…': 'Rechercher refs, noms, résumés, tags, texte intégral…',
  'clear filters': 'réinitialiser les filtres',
  'Status filter:': 'Filtre de statut :',
  'The text search failed: {error} — showing only refs and filenames.': 'La recherche textuelle a échoué : {error} — seuls les refs et noms de fichiers sont affichés.',
  'Searching the corpus text…': 'Recherche dans le texte du corpus…',
  'in refs and filenames': 'dans les refs et noms de fichiers',
  'only in summaries, tags or full text': 'uniquement dans les résumés, tags ou texte intégral',
  'selected': 'sélectionné(s)',
  'Confirm dates': 'Confirmer les dates',
  'Read with OCR': 'Lire avec l’OCR',
  'Re-file with the librarian': 'Reclasser avec le bibliothécaire',
  'Unlink from {code}': 'Dissocier de {code}',
  'Clear': 'Réinitialiser',
  'Nothing matches “{q}”': 'Rien ne correspond à «{q}»',
  'Nothing here under these filters': 'Rien ici sous ces filtres',
  'The corpus search reads refs, filenames, summaries, tags and the extracted text of every document — try a phrase you remember reading.': 'La recherche du corpus lit les refs, noms de fichiers, résumés, tags et le texte extrait de chaque document — essayez une formule dont vous vous souvenez.',
  'The corpus has {n} document.': 'Le corpus contient {n} document.',
  'The corpus has {n} documents.': 'Le corpus contient {n} documents.',
  'Clear the filters': 'Réinitialiser les filtres',
  'Select all shown': 'Sélectionner tous les documents affichés',
  'Effective': 'Date d’effet',
  'Ref': 'Réf',
  'Document': 'Document',
  'Yield': 'Rendement',
  'Hold‖corpus': 'Réserve',

  // ── the row ──
  'pair open': 'paire ouverte',
  'needs OCR': 'OCR nécessaire',
  'Reading with the vision model': 'Lecture en cours avec le modèle de vision',
  'reading…': 'lecture…',
  'The librarian is filing this document': 'Le bibliothécaire classe ce document',
  'filing…': 'classement…',
  'extraction failed': 'échec de l’extraction',
  '{n} attachment unread': '{n} pièce jointe non lue',
  'Identical bytes arrived again and were not duplicated': 'Des octets identiques sont arrivés à nouveau et n’ont pas été dupliqués',
  're-uploaded {n}×': 'retéléversé {n}×',
  'Save and confirm': 'Enregistrer et confirmer',
  'Confirmed by the operator': 'Confirmé par l’opérateur',
  'Detected from {source} — unconfirmed': 'Détecté depuis {source} — non confirmé',
  'Type the date the content was true — saved and confirmed in one step': 'Saisissez la date à laquelle le contenu était valable — enregistrée et confirmée en une seule étape',
  'set date': 'définir la date',
  'Classification held by you': 'Classification retenue par vous',
  'Classified by the librarian — not yet held': 'Classifiée par le bibliothécaire — pas encore retenue',
  'unfiled': 'non classé',
  '{n} pp': '{n} p.',
  '{n} chars': '{n} caractères',
  'in {n} requirement': 'dans {n} exigence',
  'in {n} requirements': 'dans {n} exigences',
  'never opened': 'jamais ouvert',
  'read, nothing cited': 'lu, rien cité',
  'coverage unknown': 'couverture inconnue',
  // month groups (monthOf) — English month name + year, translated in DocRow
  'January': 'janvier', 'February': 'février', 'March': 'mars', 'April': 'avril', 'May': 'mai', 'June': 'juin',
  'July': 'juillet', 'August': 'août', 'September': 'septembre', 'October': 'octobre', 'November': 'novembre', 'December': 'décembre',
  'No effective date': 'Aucune date d’effet',

  // ── the panel ──
  'client #{id}': 'client #{id}',
  'linked to': 'lié à',
  'not linked to any engagement': 'non lié à un mandat',
  'The librarian has not summarised this document.': 'Le bibliothécaire n’a pas résumé ce document.',
  '{spans} in {reqs}': '{spans} dans {reqs}',
  '{n} span': '{n} extrait',
  '{n} spans': '{n} extraits',
  '{n} requirement': '{n} exigence',
  '{n} requirements': '{n} exigences',
  'read by the agent, nothing cited': 'lu par l’agent, rien cité',
  'never opened by the agent': 'jamais ouvert par l’agent',
  'further spans —': 'autres extraits —',
  'open the register filtered to {ref}': 'ouvrir le registre filtré sur {ref}',
  'Nothing in the register cites this document.': 'Rien dans le registre ne cite ce document.',
  'An extraction run has read it, so this is a finding, not a gap — the document carries no requirement.': 'Une exécution d’extraction l’a lu ; c’est donc un constat, pas une lacune — le document ne porte aucune exigence.',
  'No extraction run has ever opened it.': 'Aucune exécution d’extraction ne l’a jamais ouvert.',
  'Until one does, the register has not been checked against it.': 'Tant que ce n’est pas fait, le registre n’a pas été vérifié par rapport à lui.',
  'No run coverage is recorded for this engagement.': 'Aucune couverture d’exécution n’est enregistrée pour ce mandat.',
  'Run a targeted pass over {ref}': 'Lancer une passe ciblée sur {ref}',
  'Queue {ref} for extraction': 'Mettre {ref} en file pour l’extraction',
  'Effective date': 'Date d’effet',
  'not detected': 'non détectée',
  '— unconfirmed. The file mtime is never used.': '— non confirmée. L’horodatage de modification du fichier n’est jamais utilisé.',
  'Confirm': 'Confirmer',
  'decided': 'tranché',
  'Decide the pair': 'Trancher la paire',
  'names this document as a near-duplicate:': 'désigne ce document comme quasi-doublon :',
  'No text layer.': 'Aucune couche de texte.',
  'Reading…‖ocr': 'Lecture…',
  'Extraction failed:': 'Échec de l’extraction :',
  'attachment(s) were unsupported at ingest:': 'pièce(s) jointe(s) non prise(s) en charge lors de l’ingestion :',
  'Re-scanning…': 'Nouveau scan en cours…',
  'Re-scan attachments': 'Rescanner les pièces jointes',
  'Classification': 'Classification',
  'held by you': 'retenue par vous',
  'the librarian’s, not yet held': 'celle du bibliothécaire, pas encore retenue',
  'Form — the document’s kind': 'Forme — le genre du document',
  '— unclassified —': '— non classifié —',
  'Subjects — comma-separated': 'Sujets — séparés par des virgules',
  'Summary — one line': 'Résumé — une ligne',
  'Effective date — the date the content was true': 'Date d’effet — la date à laquelle le contenu était valable',
  'Source type': 'Type de source',
  'upload': 'téléversement',
  'transcript': 'transcription',
  'note': 'note',
  'url': 'URL',
  'Authored by': 'Rédigé par',
  'Save — and hold it': 'Enregistrer — et retenir',
  'Cancel': 'Annuler',
  'Form': 'Forme',
  'Subjects': 'Sujets',
  'The summary is the lead line at the top of this panel — stated once.': 'Le résumé est la ligne d’accroche en haut de ce panneau — énoncé une seule fois.',
  'Hold this classification': 'Retenir cette classification',
  'Edit…': 'Modifier…',
  'Ask the librarian to file it again — your edits always outrank the model': 'Demander au bibliothécaire de le reclasser — vos modifications ont toujours priorité sur le modèle',
  'Classifying…': 'Classification en cours…',
  'Re-run the librarian': 'Relancer le bibliothécaire',
  'Provenance': 'Provenance',
  'confirmed': 'confirmé',
  'unconfirmed': 'non confirmé',
  'Status': 'Statut',
  'processing': 'en traitement',
  'ready': 'prêt',
  'superseded': 'remplacé',
  'Source': 'Source',
  'uploaded here': 'téléversé ici',
  'linked from library': 'lié depuis la bibliothèque',
  'from library': 'depuis la bibliothèque',
  'Ingested': 'Ingéré',
  'Size': 'Taille',
  '{n} pages': '{n} pages',
  'Superseded by': 'Remplacé par',
  'Supersedes': 'Remplace',
  'Re-uploaded': 'Retéléversé',
  '— identical bytes arrived again and were not duplicated. Last:': '— des octets identiques sont arrivés à nouveau et n’ont pas été dupliqués. Dernier :',
  'Linked engagements': 'Mandats liés',
  'Not linked anywhere — this document lives only in the client library.': 'Lié nulle part — ce document vit uniquement dans la bibliothèque client.',
  'portal': 'portail',
  'Unlink': 'Dissocier',
  'Open full size in a new tab': 'Ouvrir en pleine taille dans un nouvel onglet',
  'Download original': 'Télécharger l’original',
  'Hide the extracted text': 'Masquer le texte extrait',
  'Read the extracted text': 'Lire le texte extrait',
  'Re-read with OCR': 'Relire avec l’OCR',
  'This text was transcribed from the image by {model} across {n} page(s).': 'Ce texte a été transcrit à partir de l’image par {model} sur {n} page(s).',
  'This text was transcribed from the image by {model}.': 'Ce texte a été transcrit à partir de l’image par {model}.',
  'the vision model': 'le modèle de vision',
  'Evidence quoted from it is quoted from a machine transcription — check the original before it reaches a contract.': 'Les preuves qui en sont citées proviennent d’une transcription automatique — vérifiez l’original avant qu’il n’entre dans un contrat.',
  'Only the first {pages} pages were read; {rest} remain.': 'Seules les {pages} premières pages ont été lues ; {rest} restent.',
  'OCR failed:': 'Échec de l’OCR :',
  'Show all {n} chars': 'Afficher les {n} caractères',
  'Show first {n}': 'Afficher les {n} premiers',
  'This source produced no text layer.': 'Cette source n’a produit aucune couche de texte.',
  'Attachment re-scan —': 'Nouveau scan des pièces jointes —',
  'attachment': 'pièce jointe',
  'attachments': 'pièces jointes',
  'already present': 'déjà présent',
  'unsupported': 'non pris en charge',
  'Disposals — supersede, unlink, delete': 'Élimination — remplacer, dissocier, supprimer',
  'Supersede': 'Remplacer',
  'keeps a document that was real and has been overtaken — it keeps its evidence and its place in the chain.': 'conserve un document qui était authentique et a été dépassé — il garde ses preuves et sa place dans la chaîne.',
  'removes it from': 'le retire de',
  'only; it stays in the client library.': '— seulement ; il reste dans la bibliothèque client.',
  'Delete': 'Supprimer',
  'is for one that should never have been ingested: the row and the file go, and only the audit entry survives.': 'sert à un document qui n’aurait jamais dû être ingéré : la ligne et le fichier disparaissent, seule l’entrée de la piste d’audit survit.',
  'Mark superseded by…': 'Marquer comme remplacé par…',
  '— not superseded —': '— non remplacé —',
  'no date': 'sans date',
  'Apply': 'Appliquer',
  'Clear supersession': 'Annuler le remplacement',
  'Delete {ref}': 'Supprimer {ref}',

  // ── new note ──
  'Title': 'Titre',
  'e.g. Toby — regulatory affairs scoping call': 'p. ex. Toby — entretien de cadrage Affaires réglementaires',
  'Effective date (optional)': 'Date d’effet (facultatif)',
  'Body (markdown)': 'Texte (Markdown)',
  'Notes become first-class evidence — requirements can cite a verbatim span of this text.': 'Les notes deviennent des preuves à part entière — les exigences peuvent citer un extrait littéral de ce texte.',
  'Saving…': 'Enregistrement…',
  'Create note': 'Créer une note',

  // ── library picker ──
  'Add from the client library': 'Ajouter depuis la bibliothèque client',
  'These documents already exist in the client library and are not linked to': 'Ces documents existent déjà dans la bibliothèque client et ne sont pas liés à',
  'Linking makes them part of this engagement’s corpus — nothing is copied, and unlinking later leaves the document untouched.': 'En les liant, ils deviennent partie du corpus de ce mandat — rien n’est copié, et une dissociation ultérieure laisse le document intact.',
  'Search ref, filename, tag…': 'Rechercher réf, nom de fichier, tag…',
  'Nothing to link': 'Rien à lier',
  'No unlinked library documents match these filters.': 'Aucun document non lié de la bibliothèque ne correspond à ces filtres.',
  'Every document in the client library is already linked to {code}.': 'Tous les documents de la bibliothèque client sont déjà liés à {code}.',
  'Clear the picker filters': 'Réinitialiser les filtres du sélecteur',
  'Used by': 'Utilisé par',
  'library only': 'bibliothèque uniquement',
  'Linking…': 'Liaison en cours…',
  'Link': 'Lier',
  'Done': 'Terminé',

  // ── confirm modals ──
  'Mark as superseded': 'Marquer comme remplacé',
  'Mark superseded': 'Marquer comme remplacé',
  'The document keeps its evidence and stays downloadable — supersession is a status and a pointer, never a deletion. Recency arbitration will prefer the later document.': 'Le document conserve ses preuves et reste téléchargeable — le remplacement est un statut et un renvoi, jamais une suppression. L’arbitrage de récence privilégiera le document le plus récent.',
  '{ref} cannot be deleted': '{ref} ne peut pas être supprimé',
  'This document': 'Ce document',
  'Deleting…': 'Suppression…',
  'Delete permanently': 'Supprimer définitivement',
  'Supersede it instead': 'Le remplacer à la place',
  'The row and the file on disk go immediately. The audit log keeps the full record.': 'La ligne et le fichier sur le disque disparaissent immédiatement. La piste d’audit conserve l’entrée complète.',
  'go with it': 'partent avec',
  'It is linked into': 'Il est lié à',
  '— every one of those engagements loses it from its corpus.': '— chacun de ces mandats le perd de son corpus.',
  'This cannot be undone.': 'Cette action est irréversible.',
  'Cited by': 'Cité par',
  'Drop the evidence link on each of these in the Register and the document becomes deletable.': 'Retirez le lien de preuve sur chacune de ces exigences dans le registre, et le document deviendra supprimable.',
  'Unlink {ref} from {code}': 'Dissocier {ref} de {code}',
  'The document stays in the client library and in every other engagement that links it — only': 'Le document reste dans la bibliothèque client et dans chaque autre mandat qui le lie — seul',
  'loses it from its corpus. The link’s note and its portal publish flag go with the link; re-linking later starts clean.': 'le perd de son corpus. La note du lien et son indicateur de partage au portail disparaissent avec le lien ; une nouvelle liaison ultérieure repart de zéro.',
  '{ref} cannot be unlinked from {code}': '{ref} ne peut pas être dissocié de {code}',
  'Got it': 'Compris',
  'Drop the evidence link on each of these in the Register, then unlink.': 'Retirez le lien de preuve sur chacune de ces exigences dans le registre, puis dissociez.',

  // ── the pair decider ──
  'later': 'plus récent',
  'longer': 'plus long',
  'not linked to this engagement': 'non lié à ce mandat',
  'chars': 'caractères',
  'spans cited': 'extraits cités',
  'no spans cited': 'aucun extrait cité',
  '{loser} superseded by {winner}': '{loser} remplacé par {winner}',
  'same content': 'même contenu',
  'same filename': 'même nom de fichier',
  'same base name': 'même nom de base',
  'similar name': 'nom similaire',
  'Not duplicates': 'Pas des doublons',
  'is later and longer — first verb': 'est plus récent et plus long — premier verbe',
  'no ordering fact separates them': 'aucun critère d’ordre ne les distingue',
  'the other half is not linked to this engagement': 'l’autre moitié n’est pas liée à ce mandat',

  // ── evidence block ──
  'chars {start}–{end}': 'caractères {start}–{end}',
  'cited by': 'cité par',
  'Requirement status: {status}': 'Statut de l’exigence : {status}',

  // ── DOCUMENT_FOLDERS (chips, options, form line) ──
  'correspondence': 'correspondance',
  'meeting': 'réunion',
  'agreement': 'accord',
  'financial': 'finances',
  'specification': 'spécification',
  'presentation': 'présentation',
  'image': 'image',
  'deliverable': 'livrable',
  'reference': 'référence',
}, 'DocumentsPage');
